import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed801fec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "card mt-4" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-center" }, "What kind of ticket do you want to create?", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "d-flex justify-content-center align-items-md-start align-items-center flex-md-row flex-column" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Bug report"),
  /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, "Is something not working like it's supposed to? Please describe it in detail so we can fix it!")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Feature request"),
  /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, "Do you have an idea for something new we should add? Tell us about it!")
], -1))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            class: "card kind bg-warning text-dark text-center text-decoration-none",
            to: {name: 'newTicket', params: {prod: $props.prod, kind: 'issue'}}
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, {
            class: "card kind bg-primary ms-md-2 mt-md-0 mt-2 text-white text-center text-decoration-none",
            to: {name: 'newTicket', params: {prod: $props.prod, kind: 'feature'}}
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
}